module.exports = __webpack_public_path__ + "img/c1.60c6d255.jpg";